import styled, { keyframes } from "styled-components";

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const Container = styled.div`
  background-color: #f9f9f9;
  width: 320px;
  height: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  position: absolute;
  right: 0;
  animation: ${(props) => props.animation} 0.5s ease-in;
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 1.15em;
  font-family: "Fira Mono", monospace;
  font-weight: 700;
  color: #333;
  padding: 0;
  text-transform: uppercase;
  letter-spacing: 3px;
`;

export const Form = styled.form`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
`;

export const Input = styled.input`
  flex-grow: 1;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 12px;
  &:focus {
    outline: 0;
    border-color: #aaa;
  }
`;

export const Button = styled.button`
  position: absolute;
  right: 1rem;
  bottom: 0.4rem;
  background-color: initial;
  border: none;
  border-bottom: 2px solid #fff;
  color: #fff;
  cursor: pointer;
  font-family: "Fira Mono", monospace;
  font-size: 1.25em;
  font-weight: 700;
  margin-bottom: 0.5rem;
  outline: none;
  padding: 0.5rem 1rem;
  text-shadow: 0 1px 5px rgb(0 0 0 / 10%);
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 200px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ListItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  overflow-y: visible;
  border-bottom: 1px solid #ccc;
  &:last-child {
    border-bottom: 0;
  }
  &:hover {
    background-color: #eee;
  }
`;

export const Checkbox = styled.input`
  margin-right: 10px;
  appearance: none;
  width: 16px;
  height: 16px;
  border: 1px solid #333;
  border-radius: 5px;
  background-color: #fff;
  &:checked {
    background-color: #fff;
    &:after {
      content: "✔";
      font-size: 14px;
      color: #5cb85c;
      display: flex;
      justify-content: center;
    }
  }
`;

export const TodoText = styled.p`
  font-size: 1em;
  color: #333;
  text-decoration: ${(props) => (props.completed ? "line-through" : "none")};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DeleteButton = styled.button`
  font-size: 1.15em;
  font-weight: 700;
  padding: 10px;
  border: 0;
  background: transparent;
  color: #333;
  cursor: pointer;
  &:hover {
    color: red;
  }
`;
